export function JsonInput ({ placeHolder, handleJsonChange }) {
	return (<textarea
		placeholder={placeHolder}
		onInput={handleJsonChange}
	        />);
}



// WEBPACK FOOTER //
// ./components/json-input.js